import React, {Component, Fragment} from 'react';
import { translate, Trans } from "react-i18next";
import {_addNotification, _addNotificationError} from './../../../../server/util';
import {declinedReasonList} from './../../../Parent/SchoolLunchBreakfastProgram/schoolLunchBreakfastModal'
import {postWithHeaders} from "./../../../../server/actions";
import moment from 'moment';

class W_summaryReport extends Component{
    constructor(props){ 
        super(props);
        this.state={
            appData:{}
        }
        this.saveLunchBreakfast=this.saveLunchBreakfast.bind(this);
        this.formatReqObj=this.formatReqObj.bind(this);        
    }
    componentDidMount=()=>{
        this.formatReqObj();
    }
    formatReqObj=()=>{
        let reqBody={};
      reqBody.date=moment().format('MMDDYYYY');
      reqBody.status="pending";
      
      reqBody.mealSchoolId=this.props.lunchObj.mealSchoolId;
      reqBody.prmyParentEmail=this.props.lunchObj.persons[0].contact.email
      reqBody.schoolYear=this.props.schoolInfo.schoolYear;
      let persons=[];
      this.props.lunchObj.persons.map((person,p)=>{
        person.assistancePrograms=this.props.lunchObj.assistancePrograms;			
        persons.push(person)
      });
      let studentArray=[]
      this.props.lunchObj.studentList.map((student,p)=>{
        if(student.isSelected){
            if(student.liveUnderFosterCare===true){
              student.income=[];
            }
            if(this.props.lunchObj.isIncomeAfter===false){//user want to submitted without income details 
              student.income=[];
            }
          studentArray.push(student.studentRecId)
          persons.push(student)
        }            
      });
      reqBody.studentRecIds=studentArray.join(',');
      
      this.props.lunchObj.childList.map((child,p)=>{            
        persons.push(child)
      });
      this.props.lunchObj.adultList.map((adult,p)=>{            
        persons.push(adult)
      });
      reqBody.declinedReasonList=declinedReasonList.slice();
      reqBody.householdAppInfo=persons;

      this.setState({appData:reqBody});
    } 
    saveLunchBreakfast=()=>{
        let headers = {
          'Content-Type': 'application/json'
        };      
        let reqBody=this.state.appData;
      let _serStatusCode=''; 
      let url = '/householdApplication?access_token='
      
    postWithHeaders(url, JSON.stringify(reqBody),headers)
    .then((resp)=>{
      if (!resp.ok) {
          throw Error(resp.errorMessage);
      }    
      return resp.json();
    }).then(data => {
      if(data.statusCode===200){
          _addNotification(data.statusMessage,this.props.refNotify);
          this.props.jumpToStep(17);
      }else{
          _addNotificationError(data.statusMessage, this.props.refNotify);
      }
    // 
    }).catch(
      (error) => {
          console.log('Details not saved', error);
          _addNotificationError(<Trans>{`Please try again!`}</Trans>, this.props.refNotify);
      }
    );
  }
    render(){
        const {appData}= this.state;
        return(<Fragment>
            <div className="row">
                <div className="col-md-12">
                    <div className="lowerPartTitle">
                        <h4><Trans>Summary</Trans></h4>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12" id="app-content" style={{padding: '10px', border: 'solid 4px #f1eff0'}}>
                {
                    this.props.buildHtmlUI(document.getElementById('app-content'),appData)
                }
                </div>        
            </div>   
            <div className="row device-inline-btn">
                <div className="col-md-4 col-xs-4 col-sm-4">
                    <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(15);
                    }}>
                        <Trans>Previous</Trans>
                    </button> 
                </div><div className="col-md-4 col-xs-4 col-sm-4 text-center">
                    <button className="btn btn-next btn-xs bg-color-1" onClick={(e)=>{
                        let element=document.createElement('div');
                        this.props.buildHtmlUI(element,(appData||{}));
                            let contents = element.innerHTML;
                            let frame1 = document.createElement('iframe');
                            frame1.name = "frame1";
                            frame1.style.position = "absolute";
                            frame1.style.top = "-1000000px";
                            document.body.appendChild(frame1);
                            let frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
                            frameDoc.document.open();
                            frameDoc.document.write('<html><head><title></title>');
                            frameDoc.document.write('</head><body>');
                            frameDoc.document.write(contents);
                            frameDoc.document.write('</body></html>');
                            frameDoc.document.close();
                            setTimeout( ()=> {
                                window.frames["frame1"].focus();
                                window.frames["frame1"].print();
                                document.body.removeChild(frame1);
                            }, 500);
                            return false;
                    }}><Trans>Print</Trans></button>
                </div>
                <div className="col-md-4 col-xs-4 col-sm-4">
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" 
                        onClick={(e)=>{
                            this.saveLunchBreakfast();   
                        }}><Trans>Submit</Trans>
                    </button>
                </div>
          </div>
        </Fragment>);
    }
}
export default W_summaryReport


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SchoolMealProgram/newLunchApplication/w_summaryReport.jsx